export default __webpack_public_path__ + "static/media/dot.893e7fda.svg";